import { DateTime } from "luxon";

import { DynamicContentTab, EnhancedDynamicContentItem } from "../Types/DynamicContentView";
import { Center } from "./Center";

export class EnhancedCenterMessageCenter {
  center!: Center;
  messages!: EnhancedCenterMessage[];
}

export interface CenterMessageCenter {
  center: Center;
  messages: CenterMessage[];
}

export class CenterMessage {
  id?: string;
  centers!: Center[];
  title!: string;
  message!: string;
  startDateUtc!: string;
  endDateUtc?: string;
}

export class EnhancedCenterMessage extends CenterMessage {
  startDate: DateTime;
  endDate?: DateTime;

  constructor(message: CenterMessage) {
    super();
    this.id = message.id;
    this.centers = message.centers;
    this.message = message.message;
    this.title = message.title;
    this.startDateUtc = message.startDateUtc;
    this.endDateUtc = message.endDateUtc;
    this.startDate = DateTime.fromISO(message.startDateUtc);
    this.endDate = message.endDateUtc ? DateTime.fromISO(message.endDateUtc) : undefined;
  }

  /** Filter messages applicable to the provided date, otherwise utc.now if not provided. */
  static filterMessages(
    messages: EnhancedCenterMessage[],
    dateTime: DateTime = DateTime.utc()
  ): EnhancedCenterMessage[] {
    return messages.filter(m => m.startDate <= dateTime && (!m.endDate || m.endDate >= dateTime));
  }

  /** Build the Center Messages dynamic content tab from the given messages. */
  static buildCentersContentTab(messages: EnhancedCenterMessage[]): DynamicContentTab {
    const tab = new DynamicContentTab({
      title: `Center${messages.length ? ` (${messages.length})` : ""}`,
      content: this.buildCentersContent(messages)
    });
    if (tab.content.length) tab.showChildIndex = 0;
    return tab;
  }

  /** Build dynamic content items from the given center messages. */
  static buildCentersContent(messages: EnhancedCenterMessage[]): EnhancedDynamicContentItem[] {
    return messages.map(message => ({
      id: message.id || "",
      title: `${message.title}${
        message.endDate ? `, Ending: ${message.endDate.toLocaleString(DateTime.DATETIME_MED)}` : ""
      }`,
      content: [message.message],
      keywords: message.centers.map(c => c.name),
      children: undefined,
      hidden: false
    }));
  }
}
